import type { LinkProps } from '@kc-console/common-ui';
import type { ValueOf } from '@kc-console/core';

const GUIDE_DOCS_OUT_LINK_TYPE = {
  LEAN_MORE: 'lean-more',
  DIRECT_LINK: 'direct-link',
} as const;

type GuideDocsOutLinkType = ValueOf<typeof GUIDE_DOCS_OUT_LINK_TYPE>;

type GuideDocsOutLinkProps = Omit<LinkProps, 'external' | 'children'> & {
  /**
   * 기술 문서 링크에 표시할 문구를 설정합니다.
   * - 'lean-more': 자세히 보기
   * - 'direct-link': 기술 문서 바로가기
   * @default 'direct-link'
   */
  type?: GuideDocsOutLinkType;
};

export { GUIDE_DOCS_OUT_LINK_TYPE };

export type { GuideDocsOutLinkProps, GuideDocsOutLinkType };
